var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetallicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.995,
    height: 25.011,
    viewBox: "0 0 21.995 25.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.093,
    y1: -0.099,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e6e6e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.6 -2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.2,222.543V215.5a.9.9,0,0,1,.951-.968q5.547-.006,11.09,0a.911.911,0,0,1,.959.963v14.153a.9.9,0,0,1-.917.959c-.05,0-.105,0-.156,0H253.277a1,1,0,0,1-.753-.21.957.957,0,0,1-.324-.728Q252.206,226.11,252.2,222.543Zm2.789.038v4.985c0,.269,0,.269.273.269h6.87c.273,0,.273,0,.273-.269v-9.975c0-.269,0-.273-.265-.273h-6.891c-.261,0-.261,0-.261.273Z",
    transform: "translate(-204.614 -202.722)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.752,18.735c0,2.777-.008,5.549.008,8.326a.784.784,0,0,1-.85.85c-.484-.008-.968.008-1.451-.034a.687.687,0,0,1-.618-.715V10.355c0-.307,0-.307-.307-.307H39.45a.752.752,0,0,1-.85-.862V7.911a.724.724,0,0,1,.774-.774c1.073,0,2.146,0,3.218,0,.2,0,.252-.063.252-.257-.008-1.052,0-2.108,0-3.16a.733.733,0,0,1,.82-.825h1.3a.709.709,0,0,1,.8.8V6.8c0,.337,0,.337.328.337q6.86,0,13.723,0a.7.7,0,0,1,.677.345.887.887,0,0,1,.105.387c.013.475.008.955,0,1.435a.723.723,0,0,1-.724.745c-.072,0-.143,0-.215,0H46.063c-.316,0-.316,0-.316.307Q45.754,14.539,45.752,18.735Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetallicLogo);
export default __webpack_public_path__ + "static/media/metallic_logo.01f44648ab7cda7aad460f8ea6f21c29.svg";
export { ForwardRef as ReactComponent };